import React, { FC } from 'react';

const AssignmentIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.56686 1.62501H6.38356C6.16418 0.996672 5.58963 0.541672 4.91061 0.541672C4.23159 0.541672 3.65704 0.996672 3.43766 1.62501H1.25436C0.679806 1.62501 0.209717 2.1125 0.209717 2.70834V10.2917C0.209717 10.8875 0.679806 11.375 1.25436 11.375H8.56686C9.14141 11.375 9.6115 10.8875 9.6115 10.2917V2.70834C9.6115 2.1125 9.14141 1.62501 8.56686 1.62501ZM4.91061 1.48959C5.02552 1.48959 5.12476 1.54376 5.19789 1.62501C5.26057 1.69542 5.30235 1.79292 5.30235 1.89584C5.30235 2.11792 5.12476 2.30209 4.91061 2.30209C4.69646 2.30209 4.51887 2.11792 4.51887 1.89584C4.51887 1.79292 4.56065 1.69542 4.62333 1.62501C4.69646 1.54376 4.7957 1.48959 4.91061 1.48959ZM8.56686 10.2917H1.25436V2.70834H8.56686V10.2917ZM4.91061 3.25C4.04878 3.25 3.34365 3.98125 3.34365 4.875C3.34365 5.76875 4.04878 6.5 4.91061 6.5C5.77244 6.5 6.47757 5.76875 6.47757 4.875C6.47757 3.98125 5.77244 3.25 4.91061 3.25ZM4.91061 5.41667C4.62333 5.41667 4.38829 5.17292 4.38829 4.875C4.38829 4.57709 4.62333 4.33334 4.91061 4.33334C5.19789 4.33334 5.43293 4.57709 5.43293 4.875C5.43293 5.17292 5.19789 5.41667 4.91061 5.41667ZM1.77668 8.92125V9.75H8.04454V8.92125C8.04454 7.56709 5.97092 6.98209 4.91061 6.98209C3.8503 6.98209 1.77668 7.56167 1.77668 8.92125ZM2.98324 8.66667C3.34365 8.36334 4.22637 8.06 4.91061 8.06C5.59485 8.06 6.4828 8.36334 6.83798 8.66667H2.98324Z"
        fill="#666666"
      />
    </svg>
  );
};

export default AssignmentIcon;
